import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-processing-anim',
  templateUrl: './processing-anim.component.html',
  styleUrls: ['./processing-anim.component.scss']
})
export class ProcessingAnimComponent implements OnInit {

  @Input() loader;
  
  constructor() { }

  ngOnInit(): void {
  }

}
